<template>
  <div>
    <PageAllow controller="Settings" action="pushSetting" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <!-- 推送权益 -->
        <v-card>
          <v-card-title>
            {{ $t("SmsPushSetting.PushEquity.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-left">
                {{
                  $t("SmsPushSetting.PushEquity.sms_remain") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="5" v-if="settingValues">
                {{ settingValues.sms_max }}
                {{ $t("SmsPushSetting.PushEquity.sms_strip") }}
                <span
                  :class="
                    settingValues.sms_remain <= 50
                      ? 'text-caption accent--text'
                      : 'subtitle-2'
                  "
                >
                  {{
                    $t("SmsPushSetting.PushEquity.remain_count", [
                      settingValues.sms_remain,
                      $t("SmsPushSetting.PushEquity.sms_strip"),
                    ])
                  }}
                </span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 要货单推送设置 -->
        <v-card class="my-5">
          <v-card-title>
            {{ $t("SmsPushSetting.OrderPushSettings.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <!-- 要货生成推送提醒 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-left">
                {{
                  $t("SmsPushSetting.OrderPushSettings.new_order_sms_remain") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group
                  row
                  v-model="settingValues.new_order_sms_remain"
                  max="2"
                  :hint="
                    $t(
                      'SmsPushSetting.OrderPushSettings.new_order_sms_remain_hint'
                    )
                  "
                  persistent-hint
                >
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.on')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.off')"
                    :key="0"
                    :value="0"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- todo可选员工 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-left">
                {{
                  $t("SmsPushSetting.OrderPushSettings.optional_staff") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-btn
                  small
                  color="primary"
                  class="ms-1"
                  @click.stop="selectStaffsDialog = true"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("SmsPushSetting.RadioField.select_staff") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-left"> </v-col>
              <v-col cols="9" md="7">
                <v-data-table
                  :headers="headers"
                  :items="accountUserItems"
                  :loading="loading"
                  multi-sort
                  hide-default-footer
                  class="elevation-0 px-0"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          color="danger"
                          class="px-1 me-1"
                          @click="delAccountUsers(item)"
                          >fa-trash-alt
                        </v-icon>
                      </template>
                      <span>{{
                        $t("SmsPushSetting.RadioField.delete", [
                          $t("AccountUser.ObjectName"),
                        ])
                      }}</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <!-- 要货确认推送提醒 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-left">
                {{
                  $t(
                    "SmsPushSetting.OrderPushSettings.confirm_order_sms_remain"
                  ) + $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group
                  row
                  v-model="settingValues.confirm_order_sms_remain"
                  max="2"
                  :hint="
                    $t(
                      'SmsPushSetting.OrderPushSettings.confirm_order_sms_remain_hint'
                    )
                  "
                  persistent-hint
                >
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.on')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.off')"
                    :key="0"
                    :value="0"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 报表下载推送设置 -->
        <v-card class="my-5">
          <v-card-title>
            {{ $t("SmsPushSetting.ReportDownloadPushSettings.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <!-- 推送提醒 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-left">
                {{
                  $t("SmsPushSetting.ReportDownloadPushSettings.push_alerts") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group
                  row
                  v-model="settingValues.excel_download_sms_push"
                  max="2"
                  :hint="
                    $t(
                      'SmsPushSetting.ReportDownloadPushSettings.excel_push_hint'
                    )
                  "
                  persistent-hint
                >
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.on')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.off')"
                    :key="0"
                    :value="0"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
          <!-- 要货出库推送设置 -->
        <v-card class="my-5">
          <v-card-title>
            {{ $t("SmsPushSetting.orderOutSmsPushSettings.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <!-- 推送提醒 -->
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-left">
                {{
                  $t("SmsPushSetting.orderOutSmsPushSettings.push_alerts") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group
                  row
                  v-model="settingValues.order_out_sms_push"
                  max="2"
                  persistent-hint
                >
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.on')"
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="$t('SmsPushSetting.RadioField.off')"
                    :key="0"
                    :value="0"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-sheet>
    </v-sheet>
    <v-sheet class="page-opts">
      <v-card>
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn color="success" block @click="saveSettings()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("SmsPushSetting.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <SmsPushSelectStaffsDialog
      v-model="selectStaffsDialog"
      :fetchOptions="options"
      :changed="accountUsers"
      @confirm="
        addAccountUsers = $event;
        showAccountUsers();
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Settings from "@/api/settings";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SmsPushSelectStaffsDialog from "./plugins/SmsPushSelectStaffsDialog";
import AccountUsers from "@/api/account_users";

export default {
  data: () => ({
    settingValues: {},
    serverErrors: [],
    settingKeys: {
      keys: [
        "sms_max", //最大短信数
        "sms_remain", //剩余短信数
        "new_order_sms_remain", //生成要货单推送提醒
        "confirm_order_sms_remain", //确认要货单推送提醒
        "new_order_sms_remain_users", //员工推送范围
        "excel_download_sms_push", //报表下载中心推送设置
        "order_out_sms_push",
      ],
    },
    selectStaffsDialog: false,
    options: {
      mode: 1,
    },
    accountUsers: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    SmsPushSelectStaffsDialog,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("SmsPushSetting.TableTitle.organization"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "organization_name",
        },
        {
          text: i18n.t("SmsPushSetting.TableTitle.role"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "role_name",
        },
        {
          text: i18n.t("SmsPushSetting.TableTitle.staff_name"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "name",
        },
        {
          text: i18n.t("SmsPushSetting.TableTitle.tel"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "tel",
        },
        {
          text: i18n.t("SmsPushSetting.TableTitle.delete"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "actions",
        },
      ];
    },
    accountUserItems() {
      return this.accountUsers;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/sms-push-setting",
      },
      {
        text: i18n.t("SmsPushSetting.ObjectName"),
        disabled: true,
        href: "/settings/sms-push-setting",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      //获取设置
      Settings.bussinessSetting(this.settingKeys).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settingValues = response.data.settings;
            this.settingValues = Object.assign({}, this.settingValues, {
              use_tax: this.settingValues["use-tax"],
            });

            //给没有值的设置项字段赋默认值
            if (
              this.settingValues.new_order_sms_remain == null ||
              typeof this.settingValues.new_order_sms_remain == "undefined" ||
              this.settingValues.new_order_sms_remain == undefined
            ) {
              //生成要货单推送提醒
              this.settingValues.new_order_sms_remain = 0;
            }

            if (
              this.settingValues.confirm_order_sms_remain == null ||
              typeof this.settingValues.confirm_order_sms_remain ==
                "undefined" ||
              this.settingValues.confirm_order_sms_remain == undefined
            ) {
              //确认要货单推送提醒
              this.settingValues.confirm_order_sms_remain = 0;
            }

            if (
              this.settingValues.new_order_sms_remain_users == null ||
              typeof this.settingValues.new_order_sms_remain_users ==
                "undefined" ||
              this.settingValues.new_order_sms_remain_users == undefined
            ) {
              //员工推送范围
              this.settingValues.new_order_sms_remain_users = "";
            }

            if (
              this.settingValues.excel_download_sms_push == null ||
              typeof this.settingValues.excel_download_sms_push ==
                "undefined" ||
              this.settingValues.excel_download_sms_push == undefined
            ) {
              //报表下载中心推送设置
              this.settingValues.excel_download_sms_push = 0;
            }
              if (
              this.settingValues.order_out_sms_push == null ||
              typeof this.settingValues.order_out_sms_push ==
                "undefined" ||
              this.settingValues.order_out_sms_push == undefined
            ) {
              //报表下载中心推送设置
              this.settingValues.order_out_sms_push = 0;
            }
             

            if (this.settingValues.new_order_sms_remain_users !== "") {
              this.accountUsers = [];
              let choiced = JSON.parse(
                JSON.stringify(this.settingValues.new_order_sms_remain_users)
              ).map((item) => ({ id: item }));
              AccountUsers.fetch({ type: 2 }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    response.data.account_users.map((accountUser) => {
                      let isChoose = choiced.find(
                        (s) => accountUser.id == s.id
                      );
                      if (isChoose) {
                        let choosed = {
                          id: accountUser.id,
                          organization_name: accountUser.organization.name,
                          role_name: accountUser.role.role_name,
                          name: accountUser.name,
                          tel: accountUser.tel,
                        };
                        this.accountUsers.push(choosed);
                      }
                    });
                  }
                }.bind(this)
              );
            }
          }
        }.bind(this)
      );
    },
    // 更新new_order_sms_remain_users
    setNewOrderSmsRemainUsers() {
      let ids = [];
      this.accountUsers.forEach((accountUser) => {
        ids.push(accountUser.id.toString());
      });
      if (ids != []) {
        this.settingValues.new_order_sms_remain_users = JSON.stringify(ids);
      } else {
        this.settingValues.new_order_sms_remain_users = "";
      }
    },
    // popup选择返回赋值
    showAccountUsers() {
      this.accountUsers = this.addAccountUsers;
      this.setNewOrderSmsRemainUsers();
    },
    // 取消选中员工
    delAccountUsers(item) {
      let isDel = this.accountUsers.find((d) => d.id == item.id);
      if (isDel) {
        this.accountUsers.splice(
          this.accountUsers.findIndex((d) => d.id == item.id),
          1
        );
      }
      this.setNewOrderSmsRemainUsers();
    },
    // 保存设置
    saveSettings() {
      Settings.batchSave([
        {
          setting_key: "new_order_sms_remain",
          setting_value: this.settingValues.new_order_sms_remain,
        },
        {
          setting_key: "confirm_order_sms_remain",
          setting_value: this.settingValues.confirm_order_sms_remain,
        },
        {
          setting_key: "new_order_sms_remain_users",
          setting_value: this.settingValues.new_order_sms_remain_users,
        },
        {
          setting_key: "excel_download_sms_push",
          setting_value: this.settingValues.excel_download_sms_push,
        },
        {
          setting_key: "order_out_sms_push",
          setting_value: this.settingValues.order_out_sms_push,
        },
        
      ]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(
              i18n.t("SmsPushSetting.Messages.save_success")
            );
            this.getSettings();
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>